import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/lib/translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem("cosmic_lang") || "en"; } catch { return "en"; }
  });

  useEffect(() => {
    try { localStorage.setItem("cosmic_lang", lang); } catch { /* ignore */ }
  }, [lang]);

  const t = (key, fallback) => {
    return translations[lang]?.[key] || translations.en[key] || fallback || key;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
